export default "__VITE_ASSET__CggVhYRg__"